import axios from 'axios'
import store from '../store'
import router from '../router'
import config from './config'

// axios设置
const http = axios.create({
    timeout: 20000,
    baseURL: config.baseURL
})
// http request 拦截器
http.interceptors.request.use(
    config => {
        config.withCredentials = true
        config.headers['Content-Type'] = 'application/json; charset=UTF-8'
        if (store.getters.token !== '') {
            config.headers['Authorization'] = 'Bearer ' + store.getters.token
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)
// http response 拦截器
http.interceptors.response.use(
    res => {
        return res.data
    },
    error => {
        // console.dir(error)
        var err = { code: -1, msg: `Error: ${error.message}` }
        if (error.response) {
            // console.log(error.response)
            err.code = error.response.status
            switch (error.response.status) {
                case 401:
                    var _retry = false
                    var _relogin = true
                    if (
                        !_retry &&
                        error.response.headers['www-authenticate'].indexOf('The token expired') !==
                            -1 &&
                        store.getters.token_refresh > Date.parse(new Date()) / 1000
                    ) {
                        // 自动刷新token
                        _retry = true
                        const originalRequest = error.config
                        return new Promise((resolve, reject) => {
                            http.put('/api/token', `"${store.getters.token}"`).then(res => {
                                if (res.code === 0) {
                                    _relogin = false
                                    store.dispatch('loginAction', res.data)
                                    http.defaults.headers.common.Authorization =
                                        'Bearer ' + res.data.token
                                    // retry request
                                    originalRequest.headers.Authorization =
                                        'Bearer ' + res.data.token
                                    http(originalRequest).then(res => {
                                        resolve(res)
                                    })
                                }
                            })
                        })
                    }
                    if (_relogin) {
                        store.dispatch('logoutAction')
                        router.replace({
                            path: '/login',
                            query: { redirect: router.currentRoute.fullPath }
                        })
                    }
                    break
                case 400:
                    err.msg = '请求异常'
                    break
                case 403:
                    err.msg = '无权操作'
                    break
                case 404:
                    err.msg = '资源未找到'
                    break
                case 405:
                    err.msg = '请求方法未允许'
                    break
                case 408:
                    err.msg = '请求超时'
                    break
                case 500:
                    err.msg = '服务器错误'
                    break
                case 501:
                    err.msg = '网络未实现'
                    break
                case 502:
                    err.msg = '网络错误'
                    break
                case 503:
                    err.msg = '服务不可用'
                    break
                case 504:
                    err.msg = '网络超时'
                    break
                case 505:
                    err.msg = 'http版本不支持该请求'
                    break
            }
        }
        return Promise.resolve(err)
    }
)
export default http



// WEBPACK FOOTER //
// ./src/api/http.js